import { useContext } from "react";
// import { LoaderContext } from "../context/LoaderContext";
import TailoringContext from "../context/TailoringContext";
import {
  notifications,
  signin,
  signup,
  updateProfile,
} from "../services/authentication";

export const useAuth = () => {
  const { setLoader, setErrorMessage } = useContext(TailoringContext);
  // const { setErrMsg } = useContext(LoaderContext);

  const handleSignup = (data) => {
    return new Promise((resolve, reject) => {
      signup(data)
        .then((res) => {
          resolve(res);
        })
        .catch((e) => reject(e));
    });
  };

  const handleSignin = (data) => {
    return new Promise((resolve, reject) => {
      signin(data)
        .then((res) => {
          resolve(res);
        })
        .catch(reject);
    });
  };

  const handleUpdateProfile = (payload) => {
    return new Promise((resolve, reject) => {
      setLoader(true);
      setErrorMessage("")

      updateProfile(payload)
        .then((res) => {
          resolve(res);
          console.log(res.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
          setErrorMessage(error?.response?.data.error)
        })
        .finally(() => {
          setLoader(true);
        });
    });
  };

  const handleGetNotification = () => {
    return new Promise((resolve, reject) => {
      setLoader(true);

      notifications()
        .then((res) => resolve(res))
        .catch((error) => {
          reject(error);
          console.log(error);
        })
        .finally(() => setLoader(false));
    });
  };

  return {
    handleSignup,
    handleSignin,
    handleUpdateProfile,
    handleGetNotification,
  };
};
